import React from 'react';

const NoopWrapper = ({
  children,
}) => (
  <>
    {typeof children === 'function' ? children() : children}
  </>
);

export { NoopWrapper };
